"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnv = getEnv;
function getEnv() {
    return process.env.NODE_ENV;
}
//# sourceMappingURL=getEnv.js.map